import React from "react"
import { Tooltip } from "antd"

const ToolTip = ({ Body, title }) => <Tooltip title={title}>{Body}</Tooltip>

export default ToolTip
